<div *ngIf="!EditingName">
    <span class="entity-name">
        {{this.Entity.name}}
        <span *ngIf="suffix">{{suffix}}</span>
    </span>
    <span class="rename-button">
        <mat-icon title="Rename form" (click)="renameEntity()">edit</mat-icon>
    </span>
</div>

<div *ngIf="UserCanEditName && EditingName">
    <input matInput
           #entityNameInput
           class="entity-rename-input"
           type="text"
           [(ngModel)]="this.Entity.name"
           placeholder="{{EntityType}} Name"
           (keyup.enter)="save()"
           (keyup.escape)="cancelRename()"
           size="45"
           maxlength="256"
           autocomplete="off"
           required />
    <span (click)="save()" class="save-icon">
        <mat-icon title="Save the edited name for this form">check</mat-icon>
    </span>
    <span (click)="cancelRename()" class="cancel-icon">
        <mat-icon title="Cancel rename form">cancel</mat-icon>
    </span>
</div>
